/**
 * Home screen: Carousel → Schedule row → Quick actions grid.
 * Separate layouts for mobile and desktop (1024px+).
 */

import { Layout } from "../../components/layout/index.ts";
import { ErrorDisplay } from "../../components/ErrorDisplay.tsx";
import { useAnnouncementEvents } from "@/features/events/hooks";
import { useOnRestoreFromBackground } from "../../lib/use-lifecycle.ts";
import { useMediaQuery } from "../../lib/use-media-query.ts";
import { HomePageMobile } from "./HomePageMobile.tsx";
import { HomePageDesktop } from "./HomePageDesktop.tsx";

export function HomePage() {
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  // URQL hook for announcement events
  const {
    events: announcementEvents,
    isLoading,
    error: eventsError,
    refetch,
  } = useAnnouncementEvents();

  const error = eventsError?.message ?? null;

  // Refetch on restore from background
  useOnRestoreFromBackground(() => {
    refetch();
  });

  if (error) {
    return (
      <Layout wideOnDesktop={isDesktop}>
        <ErrorDisplay
          error={error}
          onRetry={() => refetch()}
          className="mt-6"
        />
      </Layout>
    );
  }

  return (
    <Layout wideOnDesktop={isDesktop}>
      {isDesktop ? (
        <HomePageDesktop
          events={announcementEvents}
          isLoading={isLoading}
        />
      ) : (
        <HomePageMobile
          events={announcementEvents}
          isLoading={isLoading}
        />
      )}
    </Layout>
  );
}
